import React, { useState } from "react";

export default function ShopMedia({ images = [], videos = [] }) {
  const [popup, setPopup] = useState(null);
  const closePopup = () => setPopup(null);

  return (
    <>
      {images.length > 0 && (
        <div className="mt-2">
          <h4 className="font-semibold text-sm mb-1">Shop Images</h4>
          <div className="flex gap-2">
            {images.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`Shop Img ${i}`}
                className="w-24 h-20 object-cover rounded cursor-pointer border border-gray-200 p-1 bg-white shadow-sm"
                onClick={() => setPopup(img)}
              />
            ))}
          </div>
        </div>
      )}
      {videos.length > 0 && (
        <div className="mt-2">
          <h4 className="font-semibold text-sm mb-1">Shop Videos</h4>
          <div className="flex gap-2">
            {videos.map((vid, i) => (
              <video key={i} controls className="w-24 h-16 rounded">
                <source src={vid} type="video/mp4" />
              </video>
            ))}
          </div>
        </div>
      )}
      {popup && (
        <div
          className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
          onClick={closePopup}
        >
          <div
            className="relative bg-white p-4 rounded-lg shadow-2xl border border-gray-200 max-w-3xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-3 right-3 bg-gray-800 text-white rounded-full w-8 h-8 flex items-center justify-center hover:bg-gray-700"
              onClick={closePopup}
            >
              ✕
            </button>
            <div className="flex items-center justify-center">
              <img src={popup} alt="Shop Preview" className="max-h-[70vh] w-auto rounded-md" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
